import React, { useState } from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const whatsappMsg =
      `Name: ${form.name}%0A` +
      `Email: ${form.email}%0A` +
      `Phone: ${form.phone}%0A` +
      `Service: ${form.service}%0A` +
      `Message: ${form.message}`;
    const waUrl = `https://wa.me/919361207761?text=${encodeURIComponent(whatsappMsg)}`;
    const win = window.open(waUrl, '_blank');
    if (!win) {
      window.location.href = waUrl;
    }
    setSubmitted(true);
  };
  return (
    <div className="contact-page">
      <section className="page-hero">
        <Container>
          <h1>Contact Us</h1>
          <p>Get in Touch With Our Care Team</p>
        </Container>
      </section>

      <section className="contact-info-section">
        <Container>
          <Row className="g-4">
            <Col lg={3} md={6}>
              <Card className="info-card text-center h-100">
                <Card.Body>
                  <FaMapMarkerAlt className="info-icon" />
                  <h4>Address</h4>
                  <p>No.41, K.R.Road Chebrole, Guntur, Andhra Pradesh - 522212, India</p>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6}>
              <Card className="info-card text-center h-100">
                <Card.Body>
                  <FaPhone className="info-icon" />
                  <h4>Phone</h4>
                  <p>
                    <a href="tel:+919361207761">+91 93612 07761</a><br />
                    <a href="tel:+919281474570">+91 9281474570</a>
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6}>
              <Card className="info-card text-center h-100">
                <Card.Body>
                  <FaEnvelope className="info-icon" />
                  <h4>Email</h4>
                  <p>
                    <a href="mailto:info@aroghyaradham.com">info@aroghyaradham.com</a>
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6}>
              <Card className="info-card text-center h-100">
                <Card.Body>
                  <FaClock className="info-icon" />
                  <h4>Working Hours</h4>
                  <p>24/7 Emergency Support<br />Office: 9 AM - 6 PM</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="contact-form-section">
        <Container>
          <Row>
            <Col lg={6} className="mb-4 mb-lg-0">
              <div>
                <h2>Send Us a Message</h2>
                <p>Fill out the form below and we'll get back to you as soon as possible.</p>
                {submitted ? (
                  <div className="alert alert-success">Thank you! We have received your details and will get back to you soon.</div>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label">Full Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={form.name}
                        onChange={handleChange}
                        placeholder="Enter your name"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email Address</label>
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="Enter your email"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Phone Number</label>
                      <input
                        type="tel"
                        name="phone"
                        className="form-control"
                        value={form.phone}
                        onChange={handleChange}
                        placeholder="Enter your phone"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Service Required</label>
                      <select
                        name="service"
                        className="form-select"
                        value={form.service}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Service</option>
                        <option>Home Based Care</option>
                        <option>Elderly Care</option>
                        <option>Palliative Care</option>
                        <option>Doctor Home Visit</option>
                        <option>Physiotherapy</option>
                        <option>Other</option>
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Message</label>
                      <textarea
                        rows={4}
                        name="message"
                        className="form-control"
                        value={form.message}
                        onChange={handleChange}
                        placeholder="Your message"
                        required
                      />
                    </div>
                    <Button variant="info" size="lg" className="w-100" type="submit">
                      Send Message
                    </Button>
                  </form>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="emergency-section">
        <Container>
          <div className="emergency-card">
            <h2>Emergency? Call Us Now!</h2>
            <p>Our team is available 24/7 for emergencies</p>
            <a href="tel:+919281474570" className="btn btn-warning btn-lg">
              +91 9281474570
            </a>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default Contact;
